/* Iron Maiden v2 PDP — size-chart data + helpers.
   Sourced from a TS module the merchant provided. Layout-only fields
   (vertical_line_*, horizontal_line_*, style_image_*, model_img(s),
   vertical_image_path, measurement_area_description) were dropped — they
   exist for a separate React size-guide modal we are not building.

   Exposes on window:
     SIZE_DATA                — per-garment chart objects
     mapProductTypeToGarment  — product.type → garment key
     lookupMeasurements       — (garmentKey, size) → measurement rows
*/
(function () {
  var SIZE_DATA = {
    hoodie: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Large'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 6'1 (185 cm)"] }
      ],
      data: [
        { size: 'XXS',   part: 'chest', value: 22,   unit: 'in' },
        { size: 'XS',    part: 'chest', value: 23,   unit: 'in' },
        { size: 'S',     part: 'chest', value: 24,   unit: 'in' },
        { size: 'M',     part: 'chest', value: 25,   unit: 'in' },
        { size: 'L',     part: 'chest', value: 26,   unit: 'in' },
        { size: 'XL',    part: 'chest', value: 27.5, unit: 'in' },
        { size: 'XXL',   part: 'chest', value: 29,   unit: 'in' },
        { size: 'XXXL',  part: 'chest', value: 30.5, unit: 'in' },
        { size: 'XXXXL', part: 'chest', value: 32,   unit: 'in' },
        { size: '12M',   part: 'chest', value: 12.25,  unit: 'in' },
        { size: '18M',   part: 'chest', value: 12.625, unit: 'in' },
        { size: '2T',    part: 'chest', value: 13,     unit: 'in' },
        { size: '3T',    part: 'chest', value: 13.375, unit: 'in' },
        { size: '4T',    part: 'chest', value: 13.75,  unit: 'in' },
        { size: '5T',    part: 'chest', value: 14.125, unit: 'in' },
        { size: '6',     part: 'chest', value: 14.5,   unit: 'in' },
        { size: '7',     part: 'chest', value: 14.875, unit: 'in' },
        { size: '8',     part: 'chest', value: 15.875, unit: 'in' },
        { size: '9',     part: 'chest', value: 16.875, unit: 'in' },
        { size: '10',    part: 'chest', value: 17.875, unit: 'in' },
        { size: 'XXS',   part: 'body-length', value: 26,    unit: 'in' },
        { size: 'XS',    part: 'body-length', value: 26.5,  unit: 'in' },
        { size: 'S',     part: 'body-length', value: 27,    unit: 'in' },
        { size: 'M',     part: 'body-length', value: 27.5,  unit: 'in' },
        { size: 'L',     part: 'body-length', value: 28,    unit: 'in' },
        { size: 'XL',    part: 'body-length', value: 28.75, unit: 'in' },
        { size: 'XXL',   part: 'body-length', value: 31.25, unit: 'in' },
        { size: 'XXXL',  part: 'body-length', value: 32.75, unit: 'in' },
        { size: 'XXXXL', part: 'body-length', value: 34.25, unit: 'in' },
        { size: '12M',   part: 'body-length', value: 13.875, unit: 'in' },
        { size: '18M',   part: 'body-length', value: 14.75,  unit: 'in' },
        { size: '2T',    part: 'body-length', value: 15.625, unit: 'in' },
        { size: '3T',    part: 'body-length', value: 16.5,   unit: 'in' },
        { size: '4T',    part: 'body-length', value: 17.375, unit: 'in' },
        { size: '5T',    part: 'body-length', value: 18.25,  unit: 'in' },
        { size: '6',     part: 'body-length', value: 19.125, unit: 'in' },
        { size: '7',     part: 'body-length', value: 20,     unit: 'in' },
        { size: '8',     part: 'body-length', value: 20.875, unit: 'in' },
        { size: '9',     part: 'body-length', value: 21.75,  unit: 'in' },
        { size: '10',    part: 'body-length', value: 22.625, unit: 'in' }
      ]
    },

    ziphoodie: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Large'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 6'1 (185 cm)"] }
      ],
      data: [
        { size: 'XXS',   part: 'chest', value: 22,   unit: 'in' },
        { size: 'XS',    part: 'chest', value: 23,   unit: 'in' },
        { size: 'S',     part: 'chest', value: 24,   unit: 'in' },
        { size: 'M',     part: 'chest', value: 25,   unit: 'in' },
        { size: 'L',     part: 'chest', value: 26,   unit: 'in' },
        { size: 'XL',    part: 'chest', value: 27.5, unit: 'in' },
        { size: 'XXL',   part: 'chest', value: 29,   unit: 'in' },
        { size: 'XXXL',  part: 'chest', value: 30.5, unit: 'in' },
        { size: 'XXXXL', part: 'chest', value: 32,   unit: 'in' },
        { size: '12M',   part: 'chest', value: 12.25,  unit: 'in' },
        { size: '18M',   part: 'chest', value: 12.625, unit: 'in' },
        { size: '2T',    part: 'chest', value: 13,     unit: 'in' },
        { size: '3T',    part: 'chest', value: 13.375, unit: 'in' },
        { size: '4T',    part: 'chest', value: 13.75,  unit: 'in' },
        { size: '5T',    part: 'chest', value: 14.125, unit: 'in' },
        { size: '6',     part: 'chest', value: 14.5,   unit: 'in' },
        { size: '7',     part: 'chest', value: 14.875, unit: 'in' },
        { size: '8',     part: 'chest', value: 15.875, unit: 'in' },
        { size: '9',     part: 'chest', value: 16.875, unit: 'in' },
        { size: '10',    part: 'chest', value: 17.875, unit: 'in' },
        { size: 'XXS',   part: 'body-length', value: 26,    unit: 'in' },
        { size: 'XS',    part: 'body-length', value: 26.5,  unit: 'in' },
        { size: 'S',     part: 'body-length', value: 27,    unit: 'in' },
        { size: 'M',     part: 'body-length', value: 27.5,  unit: 'in' },
        { size: 'L',     part: 'body-length', value: 28,    unit: 'in' },
        { size: 'XL',    part: 'body-length', value: 28.75, unit: 'in' },
        { size: 'XXL',   part: 'body-length', value: 31.25, unit: 'in' },
        { size: 'XXXL',  part: 'body-length', value: 32.75, unit: 'in' },
        { size: 'XXXXL', part: 'body-length', value: 34.25, unit: 'in' },
        { size: '12M',   part: 'body-length', value: 13.875, unit: 'in' },
        { size: '18M',   part: 'body-length', value: 14.75,  unit: 'in' },
        { size: '2T',    part: 'body-length', value: 15.625, unit: 'in' },
        { size: '3T',    part: 'body-length', value: 16.5,   unit: 'in' },
        { size: '4T',    part: 'body-length', value: 17.375, unit: 'in' },
        { size: '5T',    part: 'body-length', value: 18.25,  unit: 'in' },
        { size: '6',     part: 'body-length', value: 19.125, unit: 'in' },
        { size: '7',     part: 'body-length', value: 20,     unit: 'in' },
        { size: '8',     part: 'body-length', value: 21,     unit: 'in' },
        { size: '9',     part: 'body-length', value: 21.75,  unit: 'in' },
        { size: '10',    part: 'body-length', value: 22.625, unit: 'in' }
      ]
    },

    cropped_top_hoodie: {
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Small'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 5'7 (173 cm)"] }
      ],
      data: [
        { size: 'XS',  part: 'chest', value: 22,   unit: 'in' },
        { size: 'S',   part: 'chest', value: 23,   unit: 'in' },
        { size: 'M',   part: 'chest', value: 24,   unit: 'in' },
        { size: 'L',   part: 'chest', value: 25,   unit: 'in' },
        { size: 'XL',  part: 'chest', value: 26.5, unit: 'in' },
        { size: 'XXL', part: 'chest', value: 28,   unit: 'in' },
        { size: 'XS',  part: 'body-length', value: 19.5, unit: 'in' },
        { size: 'S',   part: 'body-length', value: 20,   unit: 'in' },
        { size: 'M',   part: 'body-length', value: 20.5, unit: 'in' },
        { size: 'L',   part: 'body-length', value: 21,   unit: 'in' },
        { size: 'XL',  part: 'body-length', value: 21.5, unit: 'in' },
        { size: 'XXL', part: 'body-length', value: 22,   unit: 'in' }
      ]
    },

    tshirt: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10', '11'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Medium'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 6'1 (185 cm)"] }
      ],
      data: [
        { size: 'XXS',   part: 'chest', value: 19.5, unit: 'in' },
        { size: 'XS',    part: 'chest', value: 20.5, unit: 'in' },
        { size: 'S',     part: 'chest', value: 21.5, unit: 'in' },
        { size: 'M',     part: 'chest', value: 22.5, unit: 'in' },
        { size: 'L',     part: 'chest', value: 23.5, unit: 'in' },
        { size: 'XL',    part: 'chest', value: 25,   unit: 'in' },
        { size: 'XXL',   part: 'chest', value: 26.5, unit: 'in' },
        { size: 'XXXL',  part: 'chest', value: 28,   unit: 'in' },
        { size: 'XXXXL', part: 'chest', value: 29.5, unit: 'in' },
        { size: '12M',   part: 'chest', value: 11.125, unit: 'in' },
        { size: '18M',   part: 'chest', value: 11.5,   unit: 'in' },
        { size: '2T',    part: 'chest', value: 11.875, unit: 'in' },
        { size: '3T',    part: 'chest', value: 12.25,  unit: 'in' },
        { size: '4T',    part: 'chest', value: 12.625, unit: 'in' },
        { size: '5T',    part: 'chest', value: 13,     unit: 'in' },
        { size: '6',     part: 'chest', value: 13.375, unit: 'in' },
        { size: '7',     part: 'chest', value: 13.75,  unit: 'in' },
        { size: '8',     part: 'chest', value: 14.75,  unit: 'in' },
        { size: '9',     part: 'chest', value: 15.75,  unit: 'in' },
        { size: '10',    part: 'chest', value: 16.75,  unit: 'in' },
        { size: '11',    part: 'chest', value: 17.75,  unit: 'in' },
        { size: 'XXS',   part: 'body-length', value: 26.5,  unit: 'in' },
        { size: 'XS',    part: 'body-length', value: 27,    unit: 'in' },
        { size: 'S',     part: 'body-length', value: 27.5,  unit: 'in' },
        { size: 'M',     part: 'body-length', value: 28,    unit: 'in' },
        { size: 'L',     part: 'body-length', value: 28.5,  unit: 'in' },
        { size: 'XL',    part: 'body-length', value: 29.25, unit: 'in' },
        { size: 'XXL',   part: 'body-length', value: 30,    unit: 'in' },
        { size: 'XXXL',  part: 'body-length', value: 30.75, unit: 'in' },
        { size: 'XXXXL', part: 'body-length', value: 31.5,  unit: 'in' },
        { size: '12M',   part: 'body-length', value: 13.375, unit: 'in' },
        { size: '18M',   part: 'body-length', value: 14.25,  unit: 'in' },
        { size: '2T',    part: 'body-length', value: 15.125, unit: 'in' },
        { size: '3T',    part: 'body-length', value: 16,     unit: 'in' },
        { size: '4T',    part: 'body-length', value: 16.875, unit: 'in' },
        { size: '5T',    part: 'body-length', value: 17.75,  unit: 'in' },
        { size: '6',     part: 'body-length', value: 18.625, unit: 'in' },
        { size: '7',     part: 'body-length', value: 19.5,   unit: 'in' },
        { size: '8',     part: 'body-length', value: 20.375, unit: 'in' },
        { size: '9',     part: 'body-length', value: 21.25,  unit: 'in' },
        { size: '10',    part: 'body-length', value: 22.125, unit: 'in' },
        { size: '11',    part: 'body-length', value: 23.125, unit: 'in' }
      ]
    },

    oversized_tshirt: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Medium'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 6'1 (185 cm)"] }
      ],
      data: [
        { size: 'XXS',   part: 'chest', value: 22,   unit: 'in' },
        { size: 'XS',    part: 'chest', value: 23,   unit: 'in' },
        { size: 'S',     part: 'chest', value: 24,   unit: 'in' },
        { size: 'M',     part: 'chest', value: 25,   unit: 'in' },
        { size: 'L',     part: 'chest', value: 26,   unit: 'in' },
        { size: 'XL',    part: 'chest', value: 27.5, unit: 'in' },
        { size: 'XXL',   part: 'chest', value: 29,   unit: 'in' },
        { size: 'XXXL',  part: 'chest', value: 30.5, unit: 'in' },
        { size: 'XXXXL', part: 'chest', value: 29.5, unit: 'in' },
        { size: '12M',   part: 'chest', value: 11.125, unit: 'in' },
        { size: '18M',   part: 'chest', value: 11.5,   unit: 'in' },
        { size: '2T',    part: 'chest', value: 11.875, unit: 'in' },
        { size: '3T',    part: 'chest', value: 12.25,  unit: 'in' },
        { size: '4T',    part: 'chest', value: 12.625, unit: 'in' },
        { size: '5T',    part: 'chest', value: 13,     unit: 'in' },
        { size: '6',     part: 'chest', value: 13.375, unit: 'in' },
        { size: '7',     part: 'chest', value: 13.75,  unit: 'in' },
        { size: '8',     part: 'chest', value: 14.75,  unit: 'in' },
        { size: '9',     part: 'chest', value: 15.75,  unit: 'in' },
        { size: '10',    part: 'chest', value: 16.75,  unit: 'in' },
        { size: 'XXS',   part: 'body-length', value: 25.5,  unit: 'in' },
        { size: 'XS',    part: 'body-length', value: 26,    unit: 'in' },
        { size: 'S',     part: 'body-length', value: 26.5,  unit: 'in' },
        { size: 'M',     part: 'body-length', value: 27,    unit: 'in' },
        { size: 'L',     part: 'body-length', value: 27.5,  unit: 'in' },
        { size: 'XL',    part: 'body-length', value: 28.25, unit: 'in' },
        { size: 'XXL',   part: 'body-length', value: 29,    unit: 'in' },
        { size: 'XXXL',  part: 'body-length', value: 29.75, unit: 'in' },
        { size: 'XXXXL', part: 'body-length', value: 31.5,  unit: 'in' },
        { size: '12M',   part: 'body-length', value: 13.375, unit: 'in' },
        { size: '18M',   part: 'body-length', value: 14.25,  unit: 'in' },
        { size: '2T',    part: 'body-length', value: 15.125, unit: 'in' },
        { size: '3T',    part: 'body-length', value: 16,     unit: 'in' },
        { size: '4T',    part: 'body-length', value: 16.875, unit: 'in' },
        { size: '5T',    part: 'body-length', value: 17.75,  unit: 'in' },
        { size: '6',     part: 'body-length', value: 18.625, unit: 'in' },
        { size: '7',     part: 'body-length', value: 19.5,   unit: 'in' },
        { size: '8',     part: 'body-length', value: 20.375, unit: 'in' },
        { size: '9',     part: 'body-length', value: 21.25,  unit: 'in' },
        { size: '10',    part: 'body-length', value: 22.125, unit: 'in' }
      ]
    },

    classic_tee: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10', '11'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Medium'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 6'1 (185 cm)"] }
      ],
      data: [
        { size: 'XXS',   part: 'chest', value: 19,   unit: 'in' },
        { size: 'XS',    part: 'chest', value: 20,   unit: 'in' },
        { size: 'S',     part: 'chest', value: 21,   unit: 'in' },
        { size: 'M',     part: 'chest', value: 22,   unit: 'in' },
        { size: 'L',     part: 'chest', value: 23,   unit: 'in' },
        { size: 'XL',    part: 'chest', value: 24.5, unit: 'in' },
        { size: 'XXL',   part: 'chest', value: 26,   unit: 'in' },
        { size: 'XXXL',  part: 'chest', value: 27.5, unit: 'in' },
        { size: 'XXXXL', part: 'chest', value: 29.5, unit: 'in' },
        { size: '12M',   part: 'chest', value: 11.125, unit: 'in' },
        { size: '18M',   part: 'chest', value: 11.5,   unit: 'in' },
        { size: '2T',    part: 'chest', value: 11.875, unit: 'in' },
        { size: '3T',    part: 'chest', value: 12.25,  unit: 'in' },
        { size: '4T',    part: 'chest', value: 12.625, unit: 'in' },
        { size: '5T',    part: 'chest', value: 13,     unit: 'in' },
        { size: '6',     part: 'chest', value: 13.375, unit: 'in' },
        { size: '7',     part: 'chest', value: 13.75,  unit: 'in' },
        { size: '8',     part: 'chest', value: 14.75,  unit: 'in' },
        { size: '9',     part: 'chest', value: 15.75,  unit: 'in' },
        { size: '10',    part: 'chest', value: 16.75,  unit: 'in' },
        { size: '11',    part: 'chest', value: 17.75,  unit: 'in' },
        { size: 'XXS',   part: 'body-length', value: 26.75, unit: 'in' },
        { size: 'XS',    part: 'body-length', value: 27.25, unit: 'in' },
        { size: 'S',     part: 'body-length', value: 27.75, unit: 'in' },
        { size: 'M',     part: 'body-length', value: 28.25, unit: 'in' },
        { size: 'L',     part: 'body-length', value: 28.75, unit: 'in' },
        { size: 'XL',    part: 'body-length', value: 29.5,  unit: 'in' },
        { size: 'XXL',   part: 'body-length', value: 30.25, unit: 'in' },
        { size: 'XXXL',  part: 'body-length', value: 31,    unit: 'in' },
        { size: 'XXXXL', part: 'body-length', value: 31.5,  unit: 'in' },
        { size: '12M',   part: 'body-length', value: 13.375, unit: 'in' },
        { size: '18M',   part: 'body-length', value: 14.25,  unit: 'in' },
        { size: '2T',    part: 'body-length', value: 15.125, unit: 'in' },
        { size: '3T',    part: 'body-length', value: 16,     unit: 'in' },
        { size: '4T',    part: 'body-length', value: 16.875, unit: 'in' },
        { size: '5T',    part: 'body-length', value: 17.75,  unit: 'in' },
        { size: '6',     part: 'body-length', value: 18.625, unit: 'in' },
        { size: '7',     part: 'body-length', value: 19.5,   unit: 'in' },
        { size: '8',     part: 'body-length', value: 20.375, unit: 'in' },
        { size: '9',     part: 'body-length', value: 21.25,  unit: 'in' },
        { size: '10',    part: 'body-length', value: 22.125, unit: 'in' },
        { size: '11',    part: 'body-length', value: 23.125, unit: 'in' }
      ]
    },

    women_boy_tee: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Small'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 5'7 (173 cm)"] }
      ],
      data: [
        { size: 'XXS',  part: 'chest', value: 17.75, unit: 'in' },
        { size: 'XS',   part: 'chest', value: 18.75, unit: 'in' },
        { size: 'S',    part: 'chest', value: 19.75, unit: 'in' },
        { size: 'M',    part: 'chest', value: 20.75, unit: 'in' },
        { size: 'L',    part: 'chest', value: 21.75, unit: 'in' },
        { size: 'XL',   part: 'chest', value: 23.25, unit: 'in' },
        { size: 'XXL',  part: 'chest', value: 24.75, unit: 'in' },
        { size: '12M',  part: 'chest', value: 11.125, unit: 'in' },
        { size: '18M',  part: 'chest', value: 11.5,   unit: 'in' },
        { size: '2T',   part: 'chest', value: 11.875, unit: 'in' },
        { size: '3T',   part: 'chest', value: 12.25,  unit: 'in' },
        { size: '4T',   part: 'chest', value: 12.625, unit: 'in' },
        { size: '5T',   part: 'chest', value: 13,     unit: 'in' },
        { size: '6',    part: 'chest', value: 13.375, unit: 'in' },
        { size: '7',    part: 'chest', value: 13.75,  unit: 'in' },
        { size: '8',    part: 'chest', value: 14.75,  unit: 'in' },
        { size: '9',    part: 'chest', value: 15.75,  unit: 'in' },
        { size: '10',   part: 'chest', value: 16.75,  unit: 'in' },
        { size: 'XXS',  part: 'body-length', value: 23,    unit: 'in' },
        { size: 'XS',   part: 'body-length', value: 23.5,  unit: 'in' },
        { size: 'S',    part: 'body-length', value: 24,    unit: 'in' },
        { size: 'M',    part: 'body-length', value: 24.5,  unit: 'in' },
        { size: 'L',    part: 'body-length', value: 25,    unit: 'in' },
        { size: 'XL',   part: 'body-length', value: 25.5,  unit: 'in' },
        { size: 'XXL',  part: 'body-length', value: 26,    unit: 'in' },
        { size: '12M',  part: 'body-length', value: 13.37,  unit: 'in' },
        { size: '18M',  part: 'body-length', value: 14.25,  unit: 'in' },
        { size: '2T',   part: 'body-length', value: 15.125, unit: 'in' },
        { size: '3T',   part: 'body-length', value: 16,     unit: 'in' },
        { size: '4T',   part: 'body-length', value: 16.875, unit: 'in' },
        { size: '5T',   part: 'body-length', value: 17.75,  unit: 'in' },
        { size: '6',    part: 'body-length', value: 18.625, unit: 'in' },
        { size: '7',    part: 'body-length', value: 19.5,   unit: 'in' },
        { size: '8',    part: 'body-length', value: 20.375, unit: 'in' },
        { size: '9',    part: 'body-length', value: 21.25,  unit: 'in' },
        { size: '10',   part: 'body-length', value: 22.125, unit: 'in' }
      ]
    },

    crewneck: {
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Small'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 5'7 (173 cm)"] }
      ],
      data: [
        { size: 'XS',  part: 'chest', value: 22.5, unit: 'in' },
        { size: 'S',   part: 'chest', value: 23.5, unit: 'in' },
        { size: 'M',   part: 'chest', value: 24.5, unit: 'in' },
        { size: 'L',   part: 'chest', value: 25.5, unit: 'in' },
        { size: 'XL',  part: 'chest', value: 27,   unit: 'in' },
        { size: 'XXL', part: 'chest', value: 28.5, unit: 'in' },
        { size: 'XS',  part: 'body-length', value: 23.5, unit: 'in' },
        { size: 'S',   part: 'body-length', value: 24,   unit: 'in' },
        { size: 'M',   part: 'body-length', value: 24.5, unit: 'in' },
        { size: 'L',   part: 'body-length', value: 25,   unit: 'in' },
        { size: 'XL',  part: 'body-length', value: 25.5, unit: 'in' },
        { size: 'XXL', part: 'body-length', value: 26,   unit: 'in' }
      ]
    },

    unisex_crewneck: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Small'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 5'7 (173 cm)"] }
      ],
      data: [
        { size: 'XXS',  part: 'chest', value: 22,   unit: 'in' },
        { size: 'XS',   part: 'chest', value: 23,   unit: 'in' },
        { size: 'S',    part: 'chest', value: 24,   unit: 'in' },
        { size: 'M',    part: 'chest', value: 25,   unit: 'in' },
        { size: 'L',    part: 'chest', value: 26,   unit: 'in' },
        { size: 'XL',   part: 'chest', value: 27.5, unit: 'in' },
        { size: 'XXL',  part: 'chest', value: 29,   unit: 'in' },
        { size: 'XXXL', part: 'chest', value: 30.5, unit: 'in' },
        { size: '12M',  part: 'chest', value: 12.25,  unit: 'in' },
        { size: '18M',  part: 'chest', value: 12.63,  unit: 'in' },
        { size: '2T',   part: 'chest', value: 13,     unit: 'in' },
        { size: '3T',   part: 'chest', value: 13.375, unit: 'in' },
        { size: '4T',   part: 'chest', value: 13.75,  unit: 'in' },
        { size: '5T',   part: 'chest', value: 14.125, unit: 'in' },
        { size: '6',    part: 'chest', value: 14.5,   unit: 'in' },
        { size: '7',    part: 'chest', value: 14.88,  unit: 'in' },
        { size: '8',    part: 'chest', value: 15.88,  unit: 'in' },
        { size: '9',    part: 'chest', value: 16.88,  unit: 'in' },
        { size: '10',   part: 'chest', value: 17.88,  unit: 'in' },
        { size: 'XXS',  part: 'body-length', value: 26,    unit: 'in' },
        { size: 'XS',   part: 'body-length', value: 26.5,  unit: 'in' },
        { size: 'S',    part: 'body-length', value: 27,    unit: 'in' },
        { size: 'M',    part: 'body-length', value: 27.5,  unit: 'in' },
        { size: 'L',    part: 'body-length', value: 28,    unit: 'in' },
        { size: 'XL',   part: 'body-length', value: 28.75, unit: 'in' },
        { size: 'XXL',  part: 'body-length', value: 29.5,  unit: 'in' },
        { size: 'XXXL', part: 'body-length', value: 30.25, unit: 'in' },
        { size: '12M',  part: 'body-length', value: 13.88,  unit: 'in' },
        { size: '18M',  part: 'body-length', value: 14.75,  unit: 'in' },
        { size: '2T',   part: 'body-length', value: 15.63,  unit: 'in' },
        { size: '3T',   part: 'body-length', value: 16.5,   unit: 'in' },
        { size: '4T',   part: 'body-length', value: 17.375, unit: 'in' },
        { size: '5T',   part: 'body-length', value: 18.25,  unit: 'in' },
        { size: '6',    part: 'body-length', value: 19.125, unit: 'in' },
        { size: '7',    part: 'body-length', value: 20,     unit: 'in' },
        { size: '8',    part: 'body-length', value: 20.875, unit: 'in' },
        { size: '9',    part: 'body-length', value: 21.75,  unit: 'in' },
        { size: '10',   part: 'body-length', value: 22.625, unit: 'in' }
      ]
    },

    jogger: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'waist',   display_name: 'Waist - Relaxed' },
        { orientation: 'vertical',   key: 'outseam', display_name: 'Outseam Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Large'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 6'1 (185 cm)"] }
      ],
      data: [
        { size: 'XXS',  part: 'waist', value: 12.5, unit: 'in' },
        { size: 'XS',   part: 'waist', value: 13.5, unit: 'in' },
        { size: 'S',    part: 'waist', value: 14.5, unit: 'in' },
        { size: 'M',    part: 'waist', value: 15.5, unit: 'in' },
        { size: 'L',    part: 'waist', value: 16.5, unit: 'in' },
        { size: 'XL',   part: 'waist', value: 18,   unit: 'in' },
        { size: 'XXL',  part: 'waist', value: 19.5, unit: 'in' },
        { size: 'XXXL', part: 'waist', value: 21,   unit: 'in' },
        { size: '12M',  part: 'waist', value: 5.5,   unit: 'in' },
        { size: '18M',  part: 'waist', value: 6.25,  unit: 'in' },
        { size: '2T',   part: 'waist', value: 7,     unit: 'in' },
        { size: '3T',   part: 'waist', value: 7.75,  unit: 'in' },
        { size: '4T',   part: 'waist', value: 8.5,   unit: 'in' },
        { size: '5T',   part: 'waist', value: 9.25,  unit: 'in' },
        { size: '6',    part: 'waist', value: 10,    unit: 'in' },
        { size: '7',    part: 'waist', value: 10.75, unit: 'in' },
        { size: '8',    part: 'waist', value: 11.75, unit: 'in' },
        { size: '9',    part: 'waist', value: 12.75, unit: 'in' },
        { size: '10',   part: 'waist', value: 13.75, unit: 'in' },
        { size: 'XXS',  part: 'outseam', value: 40.38,  unit: 'in' },
        { size: 'XS',   part: 'outseam', value: 40.88,  unit: 'in' },
        { size: 'S',    part: 'outseam', value: 41.38,  unit: 'in' },
        { size: 'M',    part: 'outseam', value: 41.875, unit: 'in' },
        { size: 'L',    part: 'outseam', value: 42.38,  unit: 'in' },
        { size: 'XL',   part: 'outseam', value: 43,     unit: 'in' },
        { size: 'XXL',  part: 'outseam', value: 43.63,  unit: 'in' },
        { size: 'XXXL', part: 'outseam', value: 44.25,  unit: 'in' },
        { size: '12M',  part: 'outseam', value: 21.25, unit: 'in' },
        { size: '18M',  part: 'outseam', value: 22,    unit: 'in' },
        { size: '2T',   part: 'outseam', value: 22.75, unit: 'in' },
        { size: '3T',   part: 'outseam', value: 23.5,  unit: 'in' },
        { size: '4T',   part: 'outseam', value: 24.25, unit: 'in' },
        { size: '5T',   part: 'outseam', value: 25.25, unit: 'in' },
        { size: '6',    part: 'outseam', value: 26.75, unit: 'in' },
        { size: '7',    part: 'outseam', value: 28,    unit: 'in' },
        { size: '8',    part: 'outseam', value: 29.25, unit: 'in' },
        { size: '9',    part: 'outseam', value: 30.5,  unit: 'in' },
        { size: '10',   part: 'outseam', value: 31.75, unit: 'in' }
      ]
    },

    women_sweatpants: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'waist',   display_name: 'Waist - Relaxed' },
        { orientation: 'vertical',   key: 'outseam', display_name: 'Outseam Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Small'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 5'7 (173 cm)"] }
      ],
      data: [
        { size: 'XXS',   part: 'waist', value: 12.25, unit: 'in' },
        { size: 'XS',    part: 'waist', value: 12.63, unit: 'in' },
        { size: 'S',     part: 'waist', value: 13,    unit: 'in' },
        { size: 'M',     part: 'waist', value: 13.38, unit: 'in' },
        { size: 'L',     part: 'waist', value: 13.88, unit: 'in' },
        { size: 'XL',    part: 'waist', value: 14.38, unit: 'in' },
        { size: 'XXL',   part: 'waist', value: 14.88, unit: 'in' },
        { size: 'XXXL',  part: 'waist', value: 15.38, unit: 'in' },
        { size: 'XXS',   part: 'outseam', value: 40.5,  unit: 'in' },
        { size: 'XS',    part: 'outseam', value: 40.88, unit: 'in' },
        { size: 'S',     part: 'outseam', value: 41.25, unit: 'in' },
        { size: 'M',     part: 'outseam', value: 41.63, unit: 'in' },
        { size: 'L',     part: 'outseam', value: 42.13, unit: 'in' },
        { size: 'XL',    part: 'outseam', value: 42.63, unit: 'in' },
        { size: 'XXL',   part: 'outseam', value: 43.13, unit: 'in' },
        { size: 'XXXL',  part: 'outseam', value: 43.63, unit: 'in' }
      ]
    },

    mens_gathered_shorts: {
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'waist',   display_name: 'Waist - Relaxed' },
        { orientation: 'vertical',   key: 'outseam', display_name: 'Outseam Length' }
      ],
      model_sizing: [],
      data: [
        { size: 'XS',  part: 'waist', value: 13.5, unit: 'in' },
        { size: 'S',   part: 'waist', value: 14.5, unit: 'in' },
        { size: 'M',   part: 'waist', value: 15.5, unit: 'in' },
        { size: 'L',   part: 'waist', value: 16.5, unit: 'in' },
        { size: 'XL',  part: 'waist', value: 18,   unit: 'in' },
        { size: 'XXL', part: 'waist', value: 19.5, unit: 'in' },
        { size: 'XS',  part: 'outseam', value: 19,     unit: 'in' },
        { size: 'S',   part: 'outseam', value: 19.5,   unit: 'in' },
        { size: 'M',   part: 'outseam', value: 20,     unit: 'in' },
        { size: 'L',   part: 'outseam', value: 20.5,   unit: 'in' },
        { size: 'XL',  part: 'outseam', value: 21.125, unit: 'in' },
        { size: 'XXL', part: 'outseam', value: 21.75,  unit: 'in' }
      ]
    },

    womens_gathered_shorts: {
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'waist',   display_name: 'Waist - Relaxed' },
        { orientation: 'vertical',   key: 'outseam', display_name: 'Outseam Length' }
      ],
      model_sizing: [],
      data: [
        { size: 'XS',  part: 'waist', value: 13,   unit: 'in' },
        { size: 'S',   part: 'waist', value: 14,   unit: 'in' },
        { size: 'M',   part: 'waist', value: 15,   unit: 'in' },
        { size: 'L',   part: 'waist', value: 16,   unit: 'in' },
        { size: 'XL',  part: 'waist', value: 17.5, unit: 'in' },
        { size: 'XXL', part: 'waist', value: 19,   unit: 'in' },
        { size: 'XS',  part: 'outseam', value: 15.375, unit: 'in' },
        { size: 'S',   part: 'outseam', value: 15.75,  unit: 'in' },
        { size: 'M',   part: 'outseam', value: 16.125, unit: 'in' },
        { size: 'L',   part: 'outseam', value: 16.5,   unit: 'in' },
        { size: 'XL',  part: 'outseam', value: 17,     unit: 'in' },
        { size: 'XXL', part: 'outseam', value: 17.5,   unit: 'in' }
      ]
    },

    denim_jacket: {
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Medium'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 6'1 (185 cm)"] }
      ],
      data: [
        { size: 'XXS',  part: 'chest', value: 21.25, unit: 'in' },
        { size: 'XS',   part: 'chest', value: 22.25, unit: 'in' },
        { size: 'S',    part: 'chest', value: 23.25, unit: 'in' },
        { size: 'M',    part: 'chest', value: 24.25, unit: 'in' },
        { size: 'L',    part: 'chest', value: 25.25, unit: 'in' },
        { size: 'XL',   part: 'chest', value: 26.75, unit: 'in' },
        { size: 'XXL',  part: 'chest', value: 28.25, unit: 'in' },
        { size: 'XXXL', part: 'chest', value: 29.75, unit: 'in' },
        { size: 'XXS',  part: 'body-length', value: 25.5, unit: 'in' },
        { size: 'XS',   part: 'body-length', value: 26,   unit: 'in' },
        { size: 'S',    part: 'body-length', value: 26.5, unit: 'in' },
        { size: 'M',    part: 'body-length', value: 27,   unit: 'in' },
        { size: 'L',    part: 'body-length', value: 27.5, unit: 'in' },
        { size: 'XL',   part: 'body-length', value: 28.5, unit: 'in' },
        { size: 'XXL',  part: 'body-length', value: 29.5, unit: 'in' },
        { size: 'XXXL', part: 'body-length', value: 30.5, unit: 'in' }
      ]
    },

    bowling_shirt: {
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      kids_sizes: ['12M', '18M', '2T', '3T', '4T', '5T', '6', '7', '8', '9', '10'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Medium'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 6'1 (185 cm)"] }
      ],
      data: [
        { size: 'XS',   part: 'chest', value: 20.5, unit: 'in' },
        { size: 'S',    part: 'chest', value: 21.5, unit: 'in' },
        { size: 'M',    part: 'chest', value: 22.5, unit: 'in' },
        { size: 'L',    part: 'chest', value: 23.5, unit: 'in' },
        { size: 'XL',   part: 'chest', value: 25,   unit: 'in' },
        { size: 'XXL',  part: 'chest', value: 26.5, unit: 'in' },
        { size: 'XXXL', part: 'chest', value: 28,   unit: 'in' },
        { size: 'XS',   part: 'body-length', value: 27,   unit: 'in' },
        { size: 'S',    part: 'body-length', value: 27.5, unit: 'in' },
        { size: 'M',    part: 'body-length', value: 28,   unit: 'in' },
        { size: 'L',    part: 'body-length', value: 29,   unit: 'in' },
        { size: 'XL',   part: 'body-length', value: 30,   unit: 'in' },
        { size: 'XXL',  part: 'body-length', value: 31,   unit: 'in' },
        { size: 'XXXL', part: 'body-length', value: 33,   unit: 'in' }
      ]
    },

    button_up_shirt: {
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      parts: [
        { orientation: 'horizontal', key: 'chest',       display_name: 'Chest' },
        { orientation: 'vertical',   key: 'body-length', display_name: 'Body Length' }
      ],
      model_sizing: [
        { title: 'Product Size', type: 'text', content: ['The model is wearing a Medium'] },
        { title: 'Model Size',   type: 'list', content: ["Height: 6'1 (185 cm)"] }
      ],
      data: [
        { size: 'XS',  part: 'chest', value: 20,   unit: 'in' },
        { size: 'S',   part: 'chest', value: 21,   unit: 'in' },
        { size: 'M',   part: 'chest', value: 22,   unit: 'in' },
        { size: 'L',   part: 'chest', value: 23,   unit: 'in' },
        { size: 'XL',  part: 'chest', value: 24.5, unit: 'in' },
        { size: 'XXL', part: 'chest', value: 26,   unit: 'in' },
        { size: 'XS',  part: 'body-length', value: 27.5,  unit: 'in' },
        { size: 'S',   part: 'body-length', value: 28,    unit: 'in' },
        { size: 'M',   part: 'body-length', value: 28.5,  unit: 'in' },
        { size: 'L',   part: 'body-length', value: 29,    unit: 'in' },
        { size: 'XL',  part: 'body-length', value: 29.75, unit: 'in' },
        { size: 'XXL', part: 'body-length', value: 30.5,  unit: 'in' }
      ]
    }
  };

  // product.type → garment key. Specific-before-general; case-insensitive.
  function mapProductTypeToGarment(productType) {
    var t = (productType || '').toLowerCase();
    if (!t) return 'hoodie';
    if (t.indexOf('zip') > -1 && t.indexOf('hood') > -1) return 'ziphoodie';
    if (t.indexOf('crop') > -1 && t.indexOf('hood') > -1) return 'cropped_top_hoodie';
    if (t.indexOf('hood') > -1) return 'hoodie';

    if (t.indexOf('crew') > -1) {
      return t.indexOf('women') > -1 ? 'crewneck' : 'unisex_crewneck';
    }

    if (t.indexOf('oversized') > -1 && (t.indexOf('tee') > -1 || t.indexOf('shirt') > -1)) return 'oversized_tshirt';
    if (t.indexOf('classic') > -1 && t.indexOf('tee') > -1) return 'classic_tee';
    if (t.indexOf('women') > -1 && (t.indexOf('tee') > -1 || t.indexOf('t-shirt') > -1)) return 'women_boy_tee';
    if (t.indexOf('boy') > -1 && t.indexOf('tee') > -1) return 'women_boy_tee';
    if (t.indexOf('tee') > -1 || t.indexOf('t-shirt') > -1 || t.indexOf('tshirt') > -1) return 'tshirt';

    if (t.indexOf('jogger') > -1) return 'jogger';
    if (t.indexOf('women') > -1 && t.indexOf('sweatpant') > -1) return 'women_sweatpants';
    if (t.indexOf('sweatpant') > -1) return 'jogger';
    if (t.indexOf('women') > -1 && t.indexOf('short') > -1) return 'womens_gathered_shorts';
    if (t.indexOf('short') > -1) return 'mens_gathered_shorts';

    if (t.indexOf('bowling') > -1) return 'bowling_shirt';
    if (t.indexOf('button') > -1) return 'button_up_shirt';
    if (t.indexOf('denim') > -1 && t.indexOf('jacket') > -1) return 'denim_jacket';

    return 'hoodie'; // fallback for the v2 template's primary use case
  }

  // Normalize "2XL" / "3XL" / "4XL" → "XXL" / "XXXL" / "XXXXL" so the
  // product's variant names line up with the dataset's "XX..." form.
  function normalizeSize(size) {
    if (!size) return size;
    var s = String(size).toUpperCase().trim();
    var m = s.match(/^(\d+)XL$/);
    if (m) {
      var count = parseInt(m[1], 10);
      var prefix = '';
      for (var i = 0; i < count; i++) prefix += 'X';
      return prefix + 'L';
    }
    return s;
  }

  function lookupMeasurements(garmentKey, size) {
    var garment = SIZE_DATA[garmentKey] || SIZE_DATA.hoodie;
    var normalized = normalizeSize(size);
    var rows = [];
    for (var i = 0; i < garment.parts.length; i++) {
      var part = garment.parts[i];
      var datum = null;
      for (var j = 0; j < garment.data.length; j++) {
        var d = garment.data[j];
        if (normalizeSize(d.size) === normalized && d.part === part.key) {
          datum = d;
          break;
        }
      }
      if (datum) {
        rows.push({
          label: part.display_name,
          valueIn: datum.value,
          unit: datum.unit,
          valueCm: Math.round(datum.value * 2.54 * 10) / 10
        });
      }
    }
    return rows;
  }

  window.SIZE_DATA = SIZE_DATA;
  window.mapProductTypeToGarment = mapProductTypeToGarment;
  window.lookupMeasurements = lookupMeasurements;
})();
